module.exports = __webpack_public_path__ + "img/jacket.be5030ca.webp";